// Subscription tier display configuration for the header badge
export const tierConfig = {
  free: { label: 'Free', emoji: '⭐', color: 'bg-gray-100 text-gray-700' },
  seedling: { label: 'Seedling', emoji: '🌱', color: 'bg-emerald-100 text-emerald-700' },
  growing: { label: 'Growing', emoji: '🌿', color: 'bg-blue-100 text-blue-700' },
  flourishing: { label: 'Flourishing', emoji: '🌳', color: 'bg-amber-100 text-amber-700' }
};
